import { httpClient } from "@coworker/http-client";

interface MerchandisingPaItem {
  product_area_no: string;
  product_area_name: string;
}

export const getMerchandisingPaList = async (): Promise<
  MerchandisingPaItem[]
> => {
  const data = await httpClient.data.get<MerchandisingPaItem[]>(
    "/business-structure-global/getMerchandisingPaList"
  );

  return data ?? [];
};
